import React from "react";
import moment from "moment-timezone";
import axios from "axios";
import { toast } from "react-toastify";
import TimezonePicker from 'react-bootstrap-timezone-picker';

import "./style.css";
import theme from "../../../../Theme/theme";
import CancelBooking from "../Modals/CancelBooking";
import ShowCallLogs from "../Modals/ShowCallLogs";
import TimePicker from "../../../../components/TimePicker";
import DatePicker from "react-datepicker";
import { Constants } from "../../../../common/constants";
import { API_URL, ERROR_HANDLE } from "../../../../config/constants";
import { isValidEmail } from '../../../../common/Utils';
import { TimeFormats, VPTSessionLengths } from "../../../../common/constants"
import SlideSwitch from "../../../../components/SlideSwitch";

export default class BookingDetail extends React.Component {

    state = {
        booking: null,
        showCancelDialog: false,
        editing: false,
        isUpcoming: false,
        progress: false,
        refund: true,
        createTrainerAvailability: true,
        noCharge: false,
        skipUnAvailability: true,
        showCallLogs: false,
    }

    componentDidMount() {
        let booking = this.props.location.state.booking
        this.setState({
            booking: booking,
            isUpcoming: this.props.location.state.isUpcoming,
            newDate: moment(booking.bookingStartTime),
            newTime: this.getTime(booking.bookingStartTime, booking.trainerSlotTimeZone),
            newDuration: booking.bookingDuration,
            newTrainerEmail: booking.trainerEmail,
            newTimezone: booking.trainerSlotTimeZone,
            newUserEmail: booking.userEmail
        });
    }

    render() {
        let { booking } = this.state
        return (
            <div>
                <div className="header">Booking {booking ? "#" + booking.bookingId : ""}</div>
                <div style={styles.root}>
                    <div className="box">
                        <div className="content">
                            {booking && this.renderContent(booking)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderContent = (booking) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                {!this.state.editing && this.renderUserTrainerDetails(booking)}
                <div className="title">DETAILS</div>
                {this.renderBookingDetail(booking)}
                {this.state.error != null && this.renderError()}
                {this.renderActions(booking)}
                {
                    this.state.showCancelDialog &&
                    <CancelBooking booking={booking} close={(data) => {
                        if (data && data.bookingStatus && data.bookingStatus !== booking.bookingStatus) {
                            let update = JSON.parse(JSON.stringify(booking))
                            update.bookingStatus = data.bookingStatus
                            this.setState({
                                booking: update
                            })
                        }
                        this.setState({
                            showCancelDialog: false,
                        })
                    }} />
                }
                {
                    this.state.showCallLogs &&
                    <ShowCallLogs booking={booking} close={() => {
                        this.setState({
                            showCallLogs: false,
                        })
                    }} />
                }
            </div>
        )
    }

    renderError = () => {
        return <div style={{ marginTop: 30, color: 'red' }}>
            {this.state.error}
        </div>
    }

    renderActions = (booking) => {
        return this.state.editing ?
            <div style={{
                display: 'flex',
                flexDirection: 'row',
            }}>
                <div className="unselectable" style={styles.action} onClick={() => {
                    this.setState({
                        editing: false
                    })
                }}>
                    Back
                </div>
                <div className="unselectable" style={styles.action} onClick={() => {
                    this.updateBooking();
                }}>
                    Save
                </div>
            </div>
            :
            <div style={{
                display: 'flex',
                flexDirection: 'row',
            }}>
                {
                    booking.bookingStatus == Constants.STATUS_CONFIRMED &&
                    booking.trainerStatus == Constants.STATUS_ACCEPTED &&
                    this.state.isUpcoming &&
                    <div className="unselectable" style={styles.action} onClick={() => {
                        this.setState({
                            showCancelDialog: true
                        })
                    }}>
                        Cancel Booking
                    </div>
                }
                {
                    this.state.isUpcoming &&
                    <div className="unselectable" style={styles.action} onClick={() => {
                        this.setState({
                            editing: true
                        })
                    }}>
                        Edit Booking
                    </div>
                }
                {
                    <div className="unselectable" style={styles.action} onClick={() => {
                        this.setState({
                            showCallLogs: true
                        })
                    }}>
                        View Call Logs
                    </div>
                }
            </div>
    }

    renderUserTrainerDetails = (booking) => {
        return <div className="person-container">
            {
                <div className="person">
                    <div className="title">Trainer</div>
                    <img src={booking.trainerProfilePicture} className="profile-image" alt="TrainerImage" />
                    <div className="name">{booking.trainerName}</div>
                    <div className="email">{booking.trainerEmail}</div>
                </div>
            }
            <div className="person">
                <div className="title">User</div>
                <img src={booking.userProfilePicture} className="profile-image" alt="TrainerImage" />
                <div className="name">{booking.userName}</div>
                <div className="email">{booking.userEmail}</div>
            </div>
        </div>
    }

    renderBookingDetail = (booking) => {
        let { editing } = this.state;
        let is_invited_users_exists = booking.invitedUsersDetails && booking.invitedUsersDetails.length > 0;
        return (
            <div className="detail-table">
                {
                    editing &&
                    this.renderEditUserEmail()
                }
                {
                    editing &&
                    this.renderEditTrainerEmail()
                }
                {
                    editing ? this.renderEditDate()
                        : this.renderDetail("Date", this.getDate(booking.bookingStartTime, booking.trainerSlotTimeZone))
                }
                {
                    editing ? this.renderEditTime()
                        : this.renderDetail("Time", this.getTime(booking.bookingStartTime, booking.trainerSlotTimeZone))
                }
                {
                    editing ? this.renderEditDuration()
                        : this.renderDetail("Duration", booking.bookingDuration + "min")
                }
                {
                    editing && this.renderNoCharge()
                }
                {
                    editing && this.renderOneOffAvailabilityOption()
                }
                {
                    editing && this.renderSkipUnavailabilityOption()
                }
                {
                    editing && this.renderRefundOption()
                }
                {editing ? this.renderEditTimezone() : this.renderDetail("Timezone", booking.trainerSlotTimeZone)}
                {this.renderDetail("Amount Paid", "$" + (booking.amountPaid ? booking.amountPaid.toFixed(2) : '0.00'))}
                {this.renderDetail("Source", booking.source != null ? booking.source : "Not Set")}
                {this.renderDetail("Status", (booking.bookingStatus == Constants.STATUS_CONFIRMED && booking.trainerStatus == Constants.STATUS_ACCEPTED) ? "CONFIRMED" : booking.bookingStatus)}
                {this.renderDetail("Is Group Session", is_invited_users_exists.toString().toUpperCase())}
                {is_invited_users_exists && this.renderInvitedUsers("Invited Users", booking.invitedUsersDetails)}
            </div>
        )
    }

    renderDetail = (label, value) => {
        return <div className="detail">
            <div className="name" style={styles.label}>{label}</div>
            <div className="email" style={{
                flex: 1,
                textAlign: "start",
                marginTop: 10
            }}>{value}</div>
        </div>
    }

    renderInvitedUsers = (label, invitedUsers) => {
        return <div className="detail">
            <div className="name" style={styles.label}>{label}</div>
            <table className="email" style={{
                flex: 1,
                flexDirection: "column",
                textAlign: "start",
                marginTop: 10
            }}>
                <tbody>
                    {invitedUsers && invitedUsers.map(user =>
                        <tr key={user.id}>
                            <td>{user.email}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    renderEditUserEmail = () => {
        return <div className="detail">
            <div className="name" style={styles.label}>User Email</div>
            <div className="email" style={styles.inputContainer}>
                <input
                    type="email"
                    style={styles.inputText}
                    value={this.state.newUserEmail}
                    onChange={this.userEmailChange}
                />
            </div>
        </div>
    }

    renderEditTrainerEmail = () => {
        return <div className="detail">
            <div className="name" style={styles.label}>Trainer Email</div>
            <div className="email" style={styles.inputContainer}>
                <input
                    type="email"
                    style={styles.inputText}
                    value={this.state.newTrainerEmail}
                    onChange={this.trainerEmailChange}
                />
            </div>
        </div>
    }

    renderEditDate = () => {
        return <div className="detail">
            <div className="name" style={styles.label}>Date</div>
            <div className="email" style={styles.inputContainer}>
                <DatePicker
                    locale="en-us"
                    selected={this.state.newDate}
                    onChange={this.dateChange} />
            </div>
        </div>
    }

    renderEditTime = () => {
        return <div className="detail">
            <div className="name" style={styles.label}>Time</div>
            <div className="email" style={styles.inputContainer}>
                <TimePicker
                    type="start"
                    changeTime={this.timeChange}
                    currentTime={this.state.newTime}
                />
            </div>
        </div>
    }

    renderEditDuration = () => {
        return <div className="detail">
            <div className="name" style={styles.label}>Duration</div>
            <div className="duration-container">
                {
                    VPTSessionLengths.map(length => this.renderDurationOptions(length))
                }
            </div>
        </div>
    }

    renderDurationOptions = (value) => {
        let duration = this.state.newDuration;
        return <div className={`duration unselectable ${duration == value ? "duration-selected" : ""}`}
            onClick={() => {
                this.setState({
                    newDuration: value
                })
            }}>{value}min</div>
    }

    renderNoCharge = () => {
        return <div className="detail" style={{ alignItems: 'center' }}>
            <div className="name" style={styles.label}>Don't Charge</div>
            <div style={{ ...styles.inputContainer, ...{ marginTop: 10 } }}>
                <SlideSwitch checked={this.state.noCharge} onClick={this.toggleNoCharge} />
            </div>
        </div>
    }

    renderOneOffAvailabilityOption = () => {
        return <div className="detail" style={{ alignItems: 'center' }}>
            <div className="name" style={styles.label}>One-Off Availability</div>
            <div style={{ ...styles.inputContainer, ...{ marginTop: 10 } }}>
                <SlideSwitch checked={this.state.createTrainerAvailability} onClick={this.toggleOneOffAvailability} />
            </div>
        </div>
    }

    renderSkipUnavailabilityOption = () => {
        return <div className="detail" style={{ alignItems: 'center' }}>
            <div className="name" style={styles.label}>Skip Unavailability</div>
            <div style={{ ...styles.inputContainer, ...{ marginTop: 10 } }}>
                <SlideSwitch checked={this.state.skipUnAvailability} onClick={this.toggleUnAvailability} />
            </div>
        </div>
    }

    renderRefundOption = () => {
        return <div className="detail" style={{ alignItems: 'center' }}>
            <div className="name" style={styles.label}>Refund</div>
            <div style={{ ...styles.inputContainer, ...{ marginTop: 10 } }}>
                <SlideSwitch checked={this.state.refund} onClick={this.toggleRefund} />
            </div>
        </div>
    }

    renderEditTimezone = () => {
        return <div className="detail">
            <div className="name" style={styles.label}>Timezone</div>
            <div style={{ ...styles.inputContainer, ...{ marginTop: 10 } }}>
                <TimezonePicker
                    className="column-style"
                    defaultValue={this.state.newTimezone}
                    absolute={true}
                    placeholder="Select TimeZone"
                    onChange={this.timezoneChange}
                />
            </div>
        </div>
    }


    userEmailChange = e => {
        this.setState({
            newUserEmail: e.target.value,
            error: null
        })
    }

    trainerEmailChange = e => {
        this.setState({
            newTrainerEmail: e.target.value,
            error: null
        })
    }

    timezoneChange = timezone => {
        this.setState({
            newTimezone: timezone,
            error: null
        })
    }

    dateChange = (date) => {
        this.setState({
            newDate: date,
            error: null
        })
    }

    timeChange = (day, type, time) => {
        this.setState({
            newTime: time,
            error: null
        })
    }

    toggleNoCharge = () => {
        this.setState({
            noCharge: !this.state.noCharge,
            error: null
        })
    }

    toggleOneOffAvailability = () => {
        this.setState({
            createTrainerAvailability: !this.state.createTrainerAvailability,
            error: null
        })
    }

    toggleUnAvailability = () => {
        this.setState({
            skipUnAvailability: !this.state.skipUnAvailability,
            error: null
        })
    }

    toggleRefund = () => {
        this.setState({
            refund: !this.state.refund,
            error: null
        })
    }

    getDate = (time, timeZone) => {
        return moment(time, TimeFormats.bookingTimeFormat).tz(timeZone).format("MMM DD, YYYY")
    }

    getTime = (time, timeZone) => {
        return moment(time, TimeFormats.bookingTimeFormat).tz(timeZone).format("hh:mm a")
    }

    updateBooking = () => {
        if (this.state.progress) return
        let { refund, newTimezone, newDate, newDuration, newTime, newTrainerEmail, newUserEmail, createTrainerAvailability, noCharge, skipUnAvailability } = this.state
        let timeMoment = moment(newTime, TimeFormats.time_am_pm);
        let cloneDate = newDate.clone()
        cloneDate.set('h', timeMoment.get('h')).set('m', timeMoment.get('m')).set('s', 0)
        let invalid = true
        let error = null
        if (!isValidEmail(this.state.newUserEmail)) {
            error = "Please enter a valid user email"
        } else if (!isValidEmail(this.state.newTrainerEmail)) {
            error = "Please enter a valid trainer email"
        } else if (this.state.newTimezone == null) {
            error = "Please select the timezone of session"
        } else if (cloneDate.tz(newTimezone, true).isBefore(moment())) {
            error = "Please select a time in the future"
        } else if (this.state.newDuration == null) {
            error = "Please select the duration of session"
        } else {
            invalid = false
        }
        if (invalid) {
            this.setState({
                error: error
            })
        } else {
            this.setState({
                progress: true
            })
            let body = {
                bookingId: this.state.booking.bookingId,
                trainerEmail: newTrainerEmail,
                userEmail: newUserEmail,
                fromTime: cloneDate.tz(newTimezone, true).format(TimeFormats.date),
                toTime: cloneDate.add(newDuration, 'm').tz(newTimezone, true).format(TimeFormats.date),
                source: Constants.SOURCE,
                userTimezone: newTimezone,
                refund: refund,
                createTrainerAvailability,
                noCharge,
                skipUnAvailability
            }
            axios.put(`${API_URL}/trainer/slot/user`, body, {
                headers: {
                    "x-access-token": localStorage.getItem("access_token")
                },
            }).then(() => {
                toast.success("Session updated successfully", { autoClose: 1000 })
                this.setState({
                    progress: false
                })
                this.props.history.goBack()
            }).catch(e => {
                this.setState({
                    progress: false
                })
                if (e.response.data && e.response.data.error) {
                    this.setState({
                        error: e.response.data.error
                    })
                }
                ERROR_HANDLE(e)
            })
        }
    }
}

const styles = {
    root: {
        margin: 20
    },
    action: {
        margin: 30,
        width: 200,
        alignSelf: 'center',
        backgroundColor: theme.color.teal,
        color: theme.color.white,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 5
    },
    label: {
        flex: 1,
        textAlign: "end",
        marginRight: 40,
    },
    inputContainer: {
        flex: 1,
        textAlign: "start",
    },
    inputText: {
        display: 'flex',
        width: '100%',
        padding: 0,
        backgroundColor: 'transparent'
    },
};